import React, { useState } from 'react';
import { subscribe } from '../../../assets/images';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { toast } from 'react-toastify';

const Subscribe = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubscribe = async () => {
    if (!email) {
      setMessage('Zəhmət olmasa email daxil edin.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await axios.post('https://www.elzabeauty.az/elza/subscribe.php', formData);

      if (response.data?.status === 1) {
        setMessage(t("Uğurla abunə oldunuz!"));
        setEmail('');
        toast.success(t("Uğurla abunə oldunuz"))
      } else {
        setMessage('Xəta baş verdi. Yenidən cəhd edin.');
      }
    } catch (error) {
      setMessage('Xəta baş verdi. Yenidən cəhd edin.');
    }
  };

  return (
    <div className="md:w-full max-w-containerSm md:max-w-full mx-auto pt-10 md:pt-20">
      <div className='rounded-xl md:rounded-none px-3 py-5'
        style={{
          backgroundImage: `url(${subscribe})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: window.innerWidth < 640 ? '365px' : '380px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <p className='text-center text-[24px] md:text-[32px] font-semibold text-white'>
          {t("Yeniliklərdən ilk siz xəbərdar olun!")}
        </p>
        <p className='text-center text-white text-[14px] md:text-[16px] mt-2 md:mt-3 md:w-[460px]'>
          {t("Yeni məhsullar, endirimlər və gözəllik sirlərindən xəbərdar olmaq üçün emailinizi qeyd edin")}
        </p>
        <div className='flex flex-col md:flex-row justify-center mt-10 md:gap-10 items-center w-full'>
          <p className='text-[white]'>{t("Email Daxil Edin")}</p>
         <input
  type="email"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  placeholder="example@gmail.com"
  className="px-4 py-3 mt-3 md:mt-0 rounded-lg w-full md:w-[330px] bg-transparent border border-[#EFE4E1] text-[#EFE4E1] placeholder-[#EFE4E1] focus:outline-none focus:ring-0"
/>

          <button 
            onClick={handleSubscribe}
            className='h-[52px] md:w-[126px] w-full rounded-lg bg-white text-firstColor mt-10 md:mt-0'
          >
            {t("Abunə Ol")}
          </button>
        </div>
      </div>
    </div>
  );
}; 

export default Subscribe;
